var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 16,
    width: 1,
    height: 1,
    fill: "#244a34"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 9,
    width: 1,
    height: 1,
    fill: "#2f5e42"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 21,
    width: 2,
    height: 2,
    fill: "#6cff86"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 13,
    width: 1,
    height: 1,
    fill: "#244a34"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 27,
    width: 1,
    height: 1,
    fill: "#2f5e42"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 43,
    width: 1,
    height: 1,
    fill: "#2f5e42"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 54,
    width: 1,
    height: 1,
    fill: "#244a34"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 47,
    width: 2,
    height: 2,
    fill: "#cfe8d6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 59,
    width: 1,
    height: 1,
    fill: "#244a34"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 39,
    width: 1,
    height: 1,
    fill: "#2f5e42"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 77,
    width: 1,
    height: 1,
    fill: "#244a34"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 88,
    width: 2,
    height: 2,
    fill: "#6cff86"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 74,
    width: 1,
    height: 1,
    fill: "#2f5e42"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 92,
    width: 1,
    height: 1,
    fill: "#244a34"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 83,
    width: 1,
    height: 1,
    fill: "#2f5e42"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 107,
    width: 1,
    height: 1,
    fill: "#244a34"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 101,
    width: 1,
    height: 1,
    fill: "#2f5e42"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 31,
    width: 1,
    height: 1,
    fill: "#244a34"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 108,
    width: 2,
    height: 2,
    fill: "#cfe8d6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.6ffe14ff565c46a7713c0537c8e941b0.svg";
export { ForwardRef as ReactComponent };